import React from "react";
import RadioButton from "../../components/radio/RadioButton";
import useFormActions from "../../../subscription/useFormActions";
import { Control, FieldValues, useController } from "react-hook-form";
import { FormComponent } from "./FormComponent";
import { checkboxesChoicesType } from "../../types/common";

/* eslint @typescript-eslint/no-explicit-any: "off" */

interface SegmentedRadioFieldsetProps<T extends FieldValues> {
	control: Control<T>;
	criterionKey: string;
	label?: string;
	radioDefinition: checkboxesChoicesType;
	required?: boolean;
}

export default function SegmentedRadioFieldset({
	control,
	criterionKey,
	label,
	radioDefinition,
	required = false,
}: SegmentedRadioFieldsetProps<any>) {
	const { onUpdateField } = useFormActions();
	const {
		field: { value, onChange },
		formState: { errors },
	} = useController({
		name: criterionKey,
		control,
		rules: {
			required,
		},
	});

	const component = {
		id: criterionKey,
		name: criterionKey,
		legend: label,
		errors,
		required,
	};

	const fields = radioDefinition.map((field) => {
		const { key, label } = field;

		return (
			<div key={key} className="segmented-input">
				<RadioButton
					currentInput={value}
					criterionKey={criterionKey}
					id={key}
					label={label}
					onInputChange={(id) => {
						onChange(id);
						onUpdateField(criterionKey, id);
					}}
				/>
			</div>
		);
	});

	return (
		<FormComponent {...component}>
			<div className="segmented-inputs">{fields}</div>
		</FormComponent>
	);
}
